import { Directive, HostListener } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[stop-propagation]',
    standalone: false,
})
export class EventPropagationDirective {
    constructor() {}
    @HostListener('click', ['$event'])
    public onClick(event: any): void {
        event.stopPropagation();
    }
}
